import { render, staticRenderFns } from "./ButtonCustom.vue?vue&type=template&id=486fd435&scoped=true"
import script from "./ButtonCustom.vue?vue&type=script&lang=js"
export * from "./ButtonCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486fd435",
  null
  
)

export default component.exports